import { Outlet } from 'react-router-dom'

const Claims = () => {
  return <Outlet />
}

export default Claims
